export const GET_FLYOUT_DATA = '@@flyout/GET_FLYOUT_DATA';
export const GET_FLYOUT_DATA_SUCCESS = '@@flyout/GET_FLYOUT_DATA_SUCCESS';
export const GET_FLYOUT_DATA_FAILURE = '@@flyout/GET_FLYOUT_DATA_FAILURE';
export const CLEAR_FLYOUT_DATA = '@@flyout/CLEAR_FLYOUT_DATA';
